
module.exports = function init_bb() {

  function disable_content_slider_touch_swipe() {
    // Only run on mobile devices
    if (window.innerWidth <= 768) {
        // Find all content sliders within elements having class 'disable-touch-swipe'
        const content_sliders = document.querySelectorAll('.disable-touch-swipe .fl-content-slider');
        content_sliders.forEach(slider_element => {
          
            // Get the bxSlider instance from the element
            // Note: We need to use getBoundingClientRect to trigger a reflow
            // which ensures the slider instance is available
            slider_element.getBoundingClientRect();
            const slider_instance = jQuery(slider_element).data('bxSlider');
            
            if (slider_instance) {
                // Disable touch functionality
                slider_instance.touchEnabled = false;
                
                // Find the wrapper element
                const slider_wrapper = slider_element.querySelector('.fl-content-slider-wrapper');
                
                if (slider_wrapper) {
                    // Remove touch event listeners
                    slider_wrapper.removeEventListener('touchstart', handle_touch, { passive: false });
                    slider_wrapper.removeEventListener('touchmove', handle_touch, { passive: false });
                    slider_wrapper.removeEventListener('touchend', handle_touch, { passive: false });
                }
            }
        });
    }
  }

  // Prevent default touch behavior
  function handle_touch(event) {
      event.preventDefault();
      event.stopPropagation();
  }

  // initialize
  disable_content_slider_touch_swipe();

  // update on resize
  window.addEventListener('resize', disable_content_slider_touch_swipe);




  function force_content_slider_update() {
    const $slider = jQuery('.fl-content-slider');
    
    // First try to get the existing instance without reinitializing
    const slider = $slider.data('bxSlider');

    // Calculate proper height
    const slides = document.querySelectorAll('.fl-content-slider-wrapper .fl-slide');
    if (!slides.length) return;

    let max_height = 0;
    slides.forEach(slide => {
        // Temporarily make the slide visible to measure it
        const was_hidden = (window.getComputedStyle(slide).display === 'none');
        if (was_hidden) {
            slide.style.display = 'block';
            slide.style.visibility = 'hidden';
            slide.style.position = 'absolute';
        }

        // Measure all important elements in the slide
        const content = slide.querySelector('.fl-slide-content-wrap');
        const photo = slide.querySelector('.fl-slide-photo-wrap');
        const content_height = content ? content.offsetHeight : 0;
        const photo_height = photo ? photo.offsetHeight : 0;
        
        // Get the maximum height needed for this slide
        const slide_height = Math.max(content_height, photo_height);
        max_height = Math.max(max_height, slide_height);

        // Restore the slide's original state
        if (was_hidden) {
            slide.style.display = '';
            slide.style.visibility = '';
            slide.style.position = '';
        }
    });

    // Add some padding
    max_height += 50; // Adjust padding as needed

    // Apply the height to necessary elements
    const wrapper = document.querySelector('.fl-content-slider-wrapper');
    if (wrapper) {
        wrapper.style.height = `${max_height}px`;
        wrapper.style.minHeight = `${max_height}px`;
    }

    // If we have a valid slider instance, try to refresh it
    if (slider && typeof slider.redrawSlider === 'function') {
        slider.redrawSlider();
    }
}


  //force_content_slider_update();
  setTimeout(force_content_slider_update, 100);
    setTimeout(force_content_slider_update, 500);
    setTimeout(force_content_slider_update, 1000);
}